import api from '../../api/auth'

const app = new Vue({
  i18n,
	el: '#authRecoveryUser',
	data () {
		return {
			mobile: '',
			username: '',
			password: '',
			passwordConfirmation: '',
			isSubmitting: false
		}
	},
	mounted () {
		this.mobile = $('#inputMobileNumber').val()

		setTimeout(() => {
			this.focus()
		}, 10)
	},
	methods: {
		focus () {
			// $('#inputVerifyCode').focus()
		},
		onSubmit (e) {
			this.$validator.validateAll().then((result) => {
				if(result) {
					this.isSubmitting = true
					e.preventDefault()

					const mobile = this.mobile

					const data = {
						mobile: mobile,
						username: this.username,
						new_password: this.password,
						confirm_new_password: this.passwordConfirmation
					}
					
					api.recoveryUser(mobile, data, (response) => {
						this.isSubmitting = false
						this.handleOnSuccess()
						this.alertSuccessMessage(response)
					}, (e) => {
						this.isSubmitting = false
						this.alertErrorMessage(e, '#authRecoveryUser')
					})
				}
			})
		},
		handleOnSuccess () {
			$('.wizard1__item').removeClass('active')
			$('#recoveryContent').hide()
			$('#successContent').removeClass('d-none')
		},
		handleOnClickUsername (value) {
			this.username = value
		},
		addClassActive (value) {
			return this.username == value
		}
	},
	watch: {
	}
})